import http from '@/utils/http'

export default {
  contractNativeCreate: data => http({ url: '/api/admin/v1/payment/contractNativeCreate', data }),
  status: data => http({ url: '/api/admin/v1/payment/status', data }),
}
